import React from 'react';
import { useGroup } from '../contexts/GroupContext';

const GroupSelector = ({ compact = false }) => {
  const { groups, currentGroup, setCurrentGroup, loading, error } = useGroup();

  const onChange = (e) => setCurrentGroup(e.target.value);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      {!compact && <span style={{ fontSize: 12, color: '#6b7280' }}>Group:</span>}
      <select
        aria-label="Select ingestion group"
        value={currentGroup || ''}
        onChange={onChange}
        disabled={loading || !!error || (groups || []).length === 0}
        className="input"
        style={{ minWidth: 160 }}
      >
        {(groups || []).length === 0 && (
          <option value="">{loading ? 'Loading…' : 'No groups'}</option>
        )}
        {(groups || []).map(g => (
          <option key={g.id || g.group_slug} value={g.group_slug}>
            {g.name || g.group_slug}
          </option>
        ))}
      </select>
    </div>
  );
};

export default GroupSelector;
